module.exports = __webpack_public_path__ + "static/img/gold2.3f50c974.webp";